import { Megaphone, ArrowRight } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";

export const AnnouncementBar = () => {
  const { announcement } = useSettings();

  if (!announcement?.active || !announcement?.text) return null;

  const isExternal = announcement.link?.startsWith("http");

  const content = (
    <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2 text-center">
      <Megaphone className="h-3.5 w-3.5 shrink-0" />
      <p className="text-xs font-medium sm:text-sm">{announcement.text}</p>
      {announcement.link && <ArrowRight className="h-3.5 w-3.5 shrink-0" />}
    </div>
  );

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-50 border-b border-primary/30 bg-gradient-to-r from-primary/25 via-accent/20 to-primary/25 text-foreground backdrop-blur-sm"
    >
      {announcement.link ? (
        <a
          href={announcement.link}
          data-testid="announcement-link"
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noopener noreferrer" : undefined}
          className="block transition-colors hover:bg-primary/10"
        >
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
};
